import type { Slicers } from 'types/services';
import { SLICER_KEYS } from 'types/services';

export const selectColors = () => (state: Slicers) => state[SLICER_KEYS.DASHBOARD].colors;
export const selectEmail = () => (state: Slicers) => state[SLICER_KEYS.DASHBOARD].email;
export const selectOverview = () => (state: Slicers) => state[SLICER_KEYS.DASHBOARD].overview;
export const selectMenuOpened = () => (state: Slicers) => state[SLICER_KEYS.DASHBOARD].menuOpened;
